module.exports = [
 {
  "start": 41,
  "end": 2500,
  "text": " Cape Cod Chandelier is a catcher "
 },
 {
  "start": 2583,
  "end": 4583,
  "text": "for a projection made from used "
 },
 {
  "start": 4667,
  "end": 6333,
  "text": "and washed underpants. "
 },
 {
  "start": 6417,
  "end": 8083,
  "text": "The buttocks is the most difficult "
 },
 {
  "start": 8208,
  "end": 10291,
  "text": "and heavy part of our body, "
 },
 {
  "start": 10375,
  "end": 12125,
  "text": "full of longing and shame "
 },
 {
  "start": 12250,
  "end": 13667,
  "text": "and also where we came out "
 },
 {
  "start": 13750,
  "end": 15333,
  "text": "to see the light of the world."
 },
 {
  "start": 15667,
  "end": 18125,
  "text": "The chandelier bridges the contradictions "
 },
 {
  "start": 18208,
  "end": 20667,
  "text": "between the things we ignore "
 },
 {
  "start": 20792,
  "end": 22125,
  "text": "and the things we long for, "
 },
 {
  "start": 22250,
  "end": 23917,
  "text": "the places we come from "
 },
 {
  "start": 24041,
  "end": 25542,
  "text": "and want to go back to."
 },
 {
  "start": 25750,
  "end": 27250,
  "text": "The concept is also a play "
 },
 {
  "start": 27291,
  "end": 28542,
  "text": "on the word light, "
 },
 {
  "start": 28959,
  "end": 30750,
  "text": "the word in contrast to heavy, "
 },
 {
  "start": 30834,
  "end": 34542,
  "text": "and light as electromagnetic waves."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room8/audio2/08_2MCACapeCodChandelier.js